import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-referrer-stat',
    templateUrl: './referrer-stat.component.html',
    styleUrls: ['./referrer-stat.component.scss'],
})
export class ReferrerStatComponent implements OnInit {
    @Input() amount: number;

    constructor() {}

    ngOnInit(): void {}

    get amountSize() {
        return (
            32 -
            (this.amount.toString().length <= 4
                ? 0
                : 5 + (this.amount.toString().length - 4) * 3.4)
        );
    }
}
